import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsletterSignUp } from '@models/api.models';

@Injectable({
    providedIn: 'root'
})
export class NewsletterService {
    constructor(private readonly http: HttpClient) {}

    public subscribeToNewsletter(payload: NewsletterSignUp): Observable<string[]> {
        return this.http.put<string[]>(`newsletter`, payload);
    }
}
